import { t } from 'i18next';
// CONTEXTS
import { useModalVolumeDiscount } from 'context/ModalVolumeDiscount/modalVolumeDiscount';
// UTILS
import { hasAnyVolDiscApplied } from './utils';
// STYLES
import styles from './TagVolumeDiscount.module.css';

export const TagVolumeDiscount = (
    drugManufacturerName,
    quantityForBonus,
    bonus = null,
    isAppliedIndex,
    checked,
): JSX.Element => {
    /* #region contexts */
    const {
        openModal,
        setDrugManufacturerName,
        setBonusProduct,
        setIsApplied,
        setQuantityProduct,
        setIsCellChecked,
    } = useModalVolumeDiscount();
    /* #endregion */

    /* #region label tag */
    const labelTag =
        bonus?.length > 1
            ? `Promociones`
            : t('bonusByQuantity.labelOfferByQuantity', {
                  value: bonus[0].paid,
                  bonus: bonus[0].free,
              });
    /* #endregion */

    /* #region validation bonus */
    const validationBonus = () => {
        let totalFree = 0;
        bonus?.map((item, index) => {
            if (isAppliedIndex[index]?.apply === true) {
                totalFree += isAppliedIndex[index]?.gift;
            }
        });
        return `${totalFree}u. de regalo`;
    };
    /* #endregion */

    return (
        <div
            className={styles['chip-discount']}
            onClick={() => {
                setDrugManufacturerName(drugManufacturerName),
                    setBonusProduct(bonus),
                    setQuantityProduct(quantityForBonus),
                    setIsCellChecked(checked),
                    setIsApplied(isAppliedIndex),
                    openModal();
            }}
        >
            {bonus?.length > 0 && (
                <div className={styles['volume-discount-container']}>
                    <div className={styles['icon-gift']}>
                        <img src="/assets/images/gift-white.svg" alt="icon gift" width={13.3} height={14} />
                    </div>
                    <span className={styles['volume-discount-text']}>
                        {hasAnyVolDiscApplied(isAppliedIndex) ? validationBonus() : labelTag}
                    </span>
                </div>
            )}
            {bonus?.length > 1 && (
                <div className={styles['icon-gift']}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M7.33301 8.66668V10.6667C7.33301 10.8556 7.3969 11.0139 7.52467 11.1417C7.65245 11.2695 7.81079 11.3333 7.99967 11.3333C8.18856 11.3333 8.3469 11.2695 8.47467 11.1417C8.60245 11.0139 8.66634 10.8556 8.66634 10.6667V8.66668H10.6663C10.8552 8.66668 11.0136 8.60279 11.1413 8.47501C11.2691 8.34723 11.333 8.1889 11.333 8.00001C11.333 7.81112 11.2691 7.65279 11.1413 7.52501C11.0136 7.39723 10.8552 7.33334 10.6663 7.33334H8.66634V5.33334C8.66634 5.14445 8.60245 4.98612 8.47467 4.85834C8.3469 4.73057 8.18856 4.66668 7.99967 4.66668C7.81079 4.66668 7.65245 4.73057 7.52467 4.85834C7.3969 4.98612 7.33301 5.14445 7.33301 5.33334V7.33334H5.33301C5.14412 7.33334 4.98579 7.39723 4.85801 7.52501C4.73023 7.65279 4.66634 7.81112 4.66634 8.00001C4.66634 8.1889 4.73023 8.34723 4.85801 8.47501C4.98579 8.60279 5.14412 8.66668 5.33301 8.66668H7.33301ZM7.99967 14.6667C7.07745 14.6667 6.21079 14.4917 5.39967 14.1417C4.58856 13.7917 3.88301 13.3167 3.28301 12.7167C2.68301 12.1167 2.20801 11.4111 1.85801 10.6C1.50801 9.7889 1.33301 8.92223 1.33301 8.00001C1.33301 7.07779 1.50801 6.21112 1.85801 5.40001C2.20801 4.5889 2.68301 3.88334 3.28301 3.28334C3.88301 2.68334 4.58856 2.20834 5.39967 1.85834C6.21079 1.50834 7.07745 1.33334 7.99967 1.33334C8.9219 1.33334 9.78856 1.50834 10.5997 1.85834C11.4108 2.20834 12.1163 2.68334 12.7163 3.28334C13.3163 3.88334 13.7913 4.5889 14.1413 5.40001C14.4913 6.21112 14.6663 7.07779 14.6663 8.00001C14.6663 8.92223 14.4913 9.7889 14.1413 10.6C13.7913 11.4111 13.3163 12.1167 12.7163 12.7167C12.1163 13.3167 11.4108 13.7917 10.5997 14.1417C9.78856 14.4917 8.9219 14.6667 7.99967 14.6667ZM7.99967 13.3333C9.48856 13.3333 10.7497 12.8167 11.783 11.7833C12.8163 10.75 13.333 9.4889 13.333 8.00001C13.333 6.51112 12.8163 5.25001 11.783 4.21668C10.7497 3.18334 9.48856 2.66668 7.99967 2.66668C6.51079 2.66668 5.24967 3.18334 4.21634 4.21668C3.18301 5.25001 2.66634 6.51112 2.66634 8.00001C2.66634 9.4889 3.18301 10.75 4.21634 11.7833C5.24967 12.8167 6.51079 13.3333 7.99967 13.3333Z"
                            fill="white"
                        />
                    </svg>
                </div>
            )}
        </div>
    );
};
